import React from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import { Form, Row, Col, Input, Button } from 'antd';
import MainFormSteped from './Form_steped';
import MainForm from './Form';

const FormItem = Form.Item;
const ButtonGroup = Button.Group;
const store = [
  'devStore'
]
@inject(...store)
@observer
class Main extends React.Component {
  static defaultProps = {
    prefixCls: 'dev-apply-top'
  }
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
    }
  }
  renderForm = () => {
    const { step } = this.state;
    const { form, formRequiredClass, devStore: { updateForm, appDetail } } = this.props;
    let { devStore: {
      currentStatus,
    } } = this.props;
    currentStatus = parseInt(currentStatus, 10);
    if (currentStatus === 0) {
      return null;
    } else if (currentStatus === 1) {
      return <MainFormSteped step={step} form={form} formRequiredClass={formRequiredClass} onStepChange={(step) => {
        updateForm(form, toJS(appDetail), step);
        this.setState({ step });
      }} />
    } else {
      return <MainForm form={this.props.form} formRequiredClass={formRequiredClass} />
    }
  }
  didFileUpload = (values) => {
    let bool = true;
    Object.keys(values).forEach(v => {
      if (v === 'usefile' || v === 'logofile' || v === 'appfile' || v === 'srcfile') {
        if (values[v] && values[v].length === 0) bool = false;
      }
    });
    return bool;
  }
  onSubmit = (opType, opName, context) => {
    const {
      form,
      devStore: { applyAppDevCodeP, appType, appDetail, addApplyDev, getDevAppDetail, updateForm, setMobxState },
    } = this.props;
    let { devStore: { currentStatus } } = this.props;
    currentStatus = parseInt(currentStatus, 10);
    if (currentStatus === 0) {
      const validates = appType === '1' ? ['s_name'] : ['s_name', 's_uuid'];
      form.validateFieldsAndScroll(validates, { scroll: { offsetBottom: 600 } },
        (errors, values) => {
          if (!errors) {
            applyAppDevCodeP({
              s_name: values.s_name,
              s_uuid: values.s_uuid,
            }).then(data => {
              getDevAppDetail({ s_id: data.s_id }).then(data => {
                const { app } = data;
                setMobxState({
                  currentStatus: app.s_status <= 1 ? 1 : app.s_status,
                  appType: app.realNumber && app.realNumber.length === 33 ? 2 : 1,
                });
                setTimeout(() => {
                  updateForm(form, app, 0);
                }, 300);
              });
            });
          }
        })
    } else {
      form.validateFieldsAndScroll((errors, values) => {
        const didFileUpload = this.didFileUpload(values);
        if (!errors && didFileUpload) {
          let params = { ...values, opType, opName };
          if (context === 2) params.s_status = 1;//退回
          addApplyDev(params).then(() => {
            getDevAppDetail({ s_id: toJS(appDetail).s_id }).then(data => {
              const { app } = data;
              setMobxState({
                currentStatus: app.s_status <= 1 ? 1 : app.s_status,
                appType: app.realNumber && app.realNumber.length === 33 ? 2 : 1,
              });
              setTimeout(() => {
                updateForm(form, app, 0);
              }, 300);
            });
          });
        }
      });
    }
  }
  render() {
    const { step } = this.state;
    const {
      prefixCls, form, formRequiredClass,
      devStore: { appType, upedit },
    } = this.props;
    let { devStore: { appDetail, currentStatus } } = this.props;
    appDetail = toJS(appDetail);
    currentStatus = parseInt(currentStatus, 10);
    const formItemLayoutHalf = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    const formItemLayout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
    };
    let approvalBtns = null;
    const me = !!localStorage.me ? JSON.parse(localStorage.me) : { role: "" };
    if (currentStatus === 0) {
      approvalBtns = (
        <Button type="primary" onClick={this.onSubmit}>☑ 创建应用</Button>
      );
    } else if (currentStatus === 1) {
      approvalBtns = (
        <Button type="primary" disabled={step !== 3} onClick={() => this.onSubmit('next', '发布应用')}>☑ 发布应用</Button>
      );
    } else if (currentStatus === 2) {
      approvalBtns = me.role === 'admin' ? (
        <ButtonGroup>
          <Button onClick={() => this.onSubmit('previous', '退回', 2)}>退回</Button>
          <Button onClick={() => this.onSubmit('edit', '修改')}>修改</Button>
          <Button type="primary" onClick={() => this.onSubmit('next', '审核')}>☑ 审核</Button>
        </ButtonGroup>
      ) : me.role === 'develop' ? (
        <Button type="primary" onClick={() => this.onSubmit('previous', '收回应用', 5)}>收回应用</Button>
      ) : null;
    } else if (currentStatus === 3) {
      approvalBtns = me.role === 'admin' ? (
        <Button type="primary" onClick={() => upedit(toJS(appDetail).s_close === '0' ? 1 : 0)}>{toJS(appDetail).s_close === '0' ? '☑ 下架应用' : '☑ 上架应用'}</Button>
      ) : me.role === 'develop' ? (
        <Button type="primary" onClick={() => this.onSubmit("next", "创建版本", 6)}>☑ 更新应用</Button>
      ) : null;
    }
    const allDisabled = currentStatus > 1;
    const { getFieldProps, isFieldValidating, getFieldError, getFieldValue } = form;
    return (
      <div className={`${prefixCls}`}>
        <Form>
          <Row>
            <Col span={10}>
              <FormItem label="应用名称" {...formItemLayoutHalf} className={formRequiredClass} hasFeedback={!allDisabled}>
                <Input {...getFieldProps("s_name", {
                  rules: [{ required: true, message: '请填写应用名称' }]
                })} disabled={allDisabled} />
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="应用编码" {...formItemLayoutHalf}>
                {
                  allDisabled ? (<span>
                    {appDetail.s_number}.{getFieldValue("s_version")}
                    <Input type="hidden" {...getFieldProps("s_version")} />
                  </span>) : (
                      <span>提交后自动生成.</span>
                    )
                }
              </FormItem>
            </Col>
            <div className={`${prefixCls}-btn`}>
              {approvalBtns}
            </div>
          </Row>
          {
            appType === 2 && (
              <Row>
                <Col span={20}>
                  <FormItem
                    label="EC应用编号："
                    className={formRequiredClass}
                    {...formItemLayout}
                    hasFeedback={!allDisabled}
                    help={isFieldValidating('s_uuid') ? '校验中...' : (getFieldError('s_uuid') || []).join(', ')}
                  >
                    <Input {...getFieldProps("s_uuid", {
                      rules: [{ required: true, len: 33, whitespace: false, message: '请填写格式正确的EC应用编号' }]
                    })}
                      disabled={allDisabled}
                    />
                  </FormItem>
                </Col>
              </Row>
            )
          }
          {this.renderForm()}
        </Form>
      </div>
    )
  }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/dev/devApply/Top.js